"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bn_js_1 = __importDefault(require("bn.js"));

var hex_1 = require("./hex");

function toBN(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var result = null;

  switch (typeof value) {
    case 'number':
      result = new bn_js_1.default(value, 10);
      break;

    case 'string':
      if (hex_1.isHex(value, 'quantity')) {
        result = new bn_js_1.default(value.slice(2), 16);
      } else {
        result = new bn_js_1.default(value, 10);
      }

      break;

    case 'object':
      if (bn_js_1.default.isBN(value)) {
        result = value;
      }

  }

  return result || defaultValue;
}

exports.toBN = toBN;